import type { IndustryContent } from '@/types/content';

export const pestControlContent: IndustryContent = {
  slug: 'pest-control',
  name: 'Pest Control',
  headline: 'The Operating System for Pest Control Companies',
  subheadline:
    'Schedule recurring treatments, track chemical usage, and manage compliance—all from one platform built for pest control pros.',
  heroImageUrl: '/images/industries/pestcontrol-hero.webp',
  painPoints: [
    {
      title: 'Chemical tracking is a compliance risk',
      description:
        'EPA reporting requirements are strict. Tracking what chemicals were used, where, and by whom is tedious and error-prone.',
      icon: 'chemical',
    },
    {
      title: 'Recurring schedules fall apart',
      description:
        'Monthly and quarterly treatments get missed or rescheduled so often that customers lose confidence in your service.',
      icon: 'calendar',
    },
    {
      title: 'License tracking is manual',
      description:
        "Technician applicator licenses and certifications expire. You find out when the state inspector shows up, not before.",
      icon: 'certificate',
    },
    {
      title: 'Service history is scattered',
      description:
        "When a customer calls about a recurring issue, you're digging through paperwork to find past treatment records.",
      icon: 'history',
    },
  ],
  features: [
    {
      title: 'Smart Dispatch Board',
      description:
        'Route techs efficiently by territory. See certifications, equipment, and chemical inventory at a glance.',
      icon: 'dispatch',
    },
    {
      title: 'Chemical Usage Tracking',
      description:
        'Log every application with product, quantity, and location. Generate EPA-compliant reports in seconds.',
      icon: 'chemical',
    },
    {
      title: 'License & Certification Management',
      description:
        'Track applicator licenses, continuing education, and certifications. Automated alerts before expiration.',
      icon: 'certificate',
    },
    {
      title: 'Recurring Service Automation',
      description:
        'Monthly, quarterly, and seasonal treatments scheduled automatically. Customers get reminders, techs get routes.',
      icon: 'recurring',
    },
    {
      title: 'Treatment History',
      description:
        'Complete service history for every property. See past treatments, pest activity, and recommendations at a glance.',
      icon: 'history',
    },
    {
      title: 'Mobile-First Experience',
      description:
        'Log treatments, capture photos of pest activity, and collect signatures on-site. Offline-capable for rural properties.',
      icon: 'mobile',
    },
  ],
  testimonial: {
    id: 'pestcontrol-1',
    quote:
      'State inspector came for an audit and I had every report ready in under 5 minutes. She said we were the most organized company she had seen all year. That peace of mind is priceless.',
    author: 'Marcus Thompson',
    role: 'Owner',
    company: 'Thompson Pest Solutions',
    industry: 'pest-control',
    stats: {
      label: 'Audit Prep Time',
      value: '5 min',
    },
  },
  stats: [
    { label: 'Compliance Report Time', value: '-90%' },
    { label: 'Recurring Service Retention', value: '96%' },
    { label: 'Techs Per Route (Avg)', value: '+20%' },
    { label: 'Customer Satisfaction', value: '4.9/5' },
  ],
  seo: {
    title: 'Pest Control Software | Scheduling & Chemical Tracking | Omniforge',
    description:
      'Pest control software built for pros. Route optimization, chemical tracking, compliance reporting, and mobile app. Start your free trial.',
    keywords: [
      'pest control software',
      'pest control scheduling software',
      'pest control business software',
      'pest control chemical tracking',
      'exterminator software',
    ],
  },
};
